import React from "react";
import DialogTitle from '@mui/material/DialogTitle';
import I18N from "oc-modules/oc-I18N";
import Button from "@mui/material/Button";
import { Typography } from "@mui/material";

export default function MessageClosure(options) {

  return function Message() {
    return <div>
        <DialogTitle id="alert-dialog-title">
            {options.message}
        </DialogTitle>
        <Button
          className="removeInterior"
          onClick={() => {
            APP.arrangement.popover = undefined;
            APP.dirty();
          }}
          sx={{ width: "100%", marginTop: "5px" }}
          variant="contained"
        >
          <Typography variant="h6">{I18N("Ok")}</Typography>
        </Button>
    </div>;
  };
}
